var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"playHead",class:['play-head', _vm.settings.darkMode && 'theme--dark'],style:({
      transform: ("translate3d(" + _vm.left + "px, 0, 0)")
    })}),_c('div',{ref:"stage",staticClass:"play-head-stage",style:({
      zIndex: _vm.inFront ? 1 : 'auto'
    }),on:{"mousedown":function($event){if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.startDrag($event)},"dblclick":_vm.startPlaying}})])}
var staticRenderFns = []

export { render, staticRenderFns }